import { render, staticRenderFns } from "./TwentyFourArticles.vue?vue&type=template&id=2c6e4366&"
import script from "./TwentyFourArticles.vue?vue&type=script&lang=js&"
export * from "./TwentyFourArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports